import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import todosSlice from './slices/todosSlice';
import habitsSlice from './slices/habitsSlice';
import remindersSlice from './slices/remindersSlice';
import notesSlice from './slices/notesSlice';
import trackersSlice from './slices/trackersSlice';
import journalSlice from './slices/journalSlice';
import userSlice from './slices/userSlice';

export const ENABLE_PERSISTENCE = false;

const todosPersistConfig = {
  key: 'todos',
  storage,
};

const habitsPersistConfig = {
  key: 'habits',
  storage,
};

const remindersPersistConfig = {
  key: 'reminders',
  storage,
};

const notesPersistConfig = {
  key: 'notes',
  storage,
};

const trackersPersistConfig = {
  key: 'trackers',
  storage,
};

const journalPersistConfig = {
  key: 'journal',
  storage,
};

const userPersistConfig = {
  key: 'user',
  storage,
};

export const store = configureStore({
  reducer: {
    todos: ENABLE_PERSISTENCE ? persistReducer(todosPersistConfig, todosSlice) as unknown as typeof todosSlice : todosSlice,
    habits: ENABLE_PERSISTENCE ? persistReducer(habitsPersistConfig, habitsSlice) as unknown as typeof habitsSlice : habitsSlice,
    reminders: ENABLE_PERSISTENCE ? persistReducer(remindersPersistConfig, remindersSlice) as unknown as typeof remindersSlice : remindersSlice,
    notes: ENABLE_PERSISTENCE ? persistReducer(notesPersistConfig, notesSlice) as unknown as typeof notesSlice : notesSlice,
    trackers: ENABLE_PERSISTENCE ? persistReducer(trackersPersistConfig, trackersSlice) as unknown as typeof trackersSlice : trackersSlice,
    journal: ENABLE_PERSISTENCE ? persistReducer(journalPersistConfig, journalSlice) as unknown as typeof journalSlice : journalSlice,
    user: ENABLE_PERSISTENCE ? persistReducer(userPersistConfig, userSlice) as unknown as typeof userSlice : userSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = ENABLE_PERSISTENCE ? persistStore(store) : null;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
